import { normalize, denormalize } from 'normalizr';
import { combineEpics, ofType } from 'redux-observable';
import {
  switchMap, catchError, mergeMap, map,
} from 'rxjs/operators';
import api from 'api/index';
import { handleError } from 'base/errors/store/actions';
import * as actionTypes from './actionTypes';
import { dashboardSchema, dashboardsSchema } from '../../../store/schema';
import {
  createDefaultDashboardSuccess,
  deleteDefaultDashboardSuccess,
  fetchAllDefaultDashboardsSuccess,
  updateDefaultDashboardSuccess,
} from './actions';
import { entitiesFetchSuccess } from '../../../store/entities/actions';
import { getEntities } from '../../../store/entities/selectors';


const fetchAllDefaultDashboards = (action$) => action$.pipe(
  ofType(actionTypes.FETCH_ALL),
  switchMap(() => api.defaultDashboards.fetchAll().pipe(
    map((response) => normalize(response.body, dashboardsSchema)),
    mergeMap(({ entities, result }) => [
      entitiesFetchSuccess(entities),
      fetchAllDefaultDashboardsSuccess(result),
    ]),
    catchError((error) => [handleError(error)]),
  )),
);


const createDefaultDashboard = (action$, state$) => action$.pipe(
  ofType(actionTypes.CREATE),
  switchMap((action) => {
    const dashboard = denormalize(action.dashboard, dashboardSchema, getEntities(state$.value));
    return api.defaultDashboards.create(dashboard).pipe(
      mergeMap((response) => {
        const { entities } = normalize(response.body, dashboardSchema);
        return [
          entitiesFetchSuccess(entities),
          createDefaultDashboardSuccess(response.body),
        ];
      }),
      catchError((error) => [handleError(error)]),
    );
  }),
);


const updateDefaultDashboard = (action$, state$) => action$.pipe(
  ofType(actionTypes.UPDATE),
  switchMap((action) => {
    const dashboard = denormalize(action.dashboard, dashboardSchema, getEntities(state$.value));
    return api.defaultDashboards.update(dashboard).pipe(
      mergeMap((response) => {
        const { entities } = normalize(response.body, dashboardSchema);
        return [
          entitiesFetchSuccess(entities),
          updateDefaultDashboardSuccess(action.dashboard.id),
        ];
      }),
      catchError((error) => [handleError(error)]),
    );
  }),
);


const deleteDefaultDashboard = (action$) => action$.pipe(
  ofType(actionTypes.DELETE),
  switchMap((action) => api.defaultDashboards.delete(action.dashboard).pipe(
    mergeMap(() => [
      deleteDefaultDashboardSuccess(action.dashboard.id),
    ]),
    catchError((error) => [handleError(error)]),
  )),
);

export default combineEpics(
  fetchAllDefaultDashboards,
  createDefaultDashboard,
  updateDefaultDashboard,
  deleteDefaultDashboard,
);
